import CampaignHeader from './crowdfunding_campaign_header'
import { connect } from 'react-redux'
import { getFullName } from 'griffin'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getCategoryLabel } from 'lib/category'
import { getInitials } from 'shared/helpers/name_helpers'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  const ownerName =
    campaign.owner.business_name ||
    getFullName({
      givenName: campaign.owner.first_name,
      surname: campaign.owner.last_name,
    })
  return {
    poolName: campaign.title,
    categoryName: getCategoryLabel(state, campaign.category),
    creatorName: ownerName,
    profileImage: campaign.owner.profile_photo,
    initials: getInitials(ownerName),
    ...ownProps,
  }
}

export default connect(mapStateToProps)(CampaignHeader)
